import * as React from 'react';
import {
  Create,
  SelectInput,
  SimpleForm,
  TextInput,
  DateInput,
  useNotify,
  useRefresh,
  useRedirect,
  required,
  ReferenceInput,
} from 'react-admin';

export const CouponCreate = (props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const onSuccess = ({ data }) => {
    console.log(data);
    notify(`Created "${data.code}" coupon`);
    redirect('/coupons');
    refresh();
  };
  return (
    <Create onSuccess={onSuccess} {...props}>
      <SimpleForm>
        <TextInput
          label="id (Can't edit)"
          source="id"
          validate={[required()]}
        />
        <TextInput
          label="code (Can't edit)"
          source="code"
          validate={[required()]}
        />
        <TextInput
          source="name"
          label="Name/Description"
          validate={[required()]}
        />
        <TextInput
          source="maxTimes"
          label="Max times to use"
          validate={[required()]}
        />
        <ReferenceInput
          label="productId (Can't edit)"
          source="productId"
          reference="products"
          validate={[required()]}
        >
          <SelectInput optionText="id" />
        </ReferenceInput>
        <DateInput source="startAt" validate={[required()]} />
        <DateInput source="expiredAt" validate={[required()]} />
      </SimpleForm>
    </Create>
  );
};
